import $ from 'jquery';

const allocationErrorMsg = 'Please update your allocations so they equal 100%.';
const $error = $('<label>', { class: 'error error-msg', html: allocationErrorMsg });

const validateAllocation = input => (parseInt(input, 10) === 100);

$.validator.addMethod('allocations', function (input, element) {
    return this.optional(element) ||
        $(element).parents('.form-text').is(':hidden') ||
        validateAllocation(input);
}, allocationErrorMsg);

const updateDisplayTotal = ({ display, hidden, value, component }) => {
    display.text(value);
    hidden.val(value);

    if (component) {
        if (validateAllocation(value)) {
            $(component).removeClass('has-error');
        } else {
            $(component).addClass('has-error');

            if ($(component).find('.error-msg').length < 1) {
                $(component).append($error);
            } else {
                $(component).find('label.error-msg').text(allocationErrorMsg);
            }
        }
    }
};

// Initializes total allocation functionality for a form component
// This function handles calculating and validating allocation totals that must sum to 100%
// Parameters:
//   index: Index of the component in the jQuery collection (unused but required by $.each)
//   component: The DOM element containing the allocation form fields
const totalAllocationInit = (index, component) => {
    let $allocationId = component.id;
    if (component.id === '') {
        $allocationId = $(component).find('.form-text').attr('id');
    }
    const $allocationItems = $(`input[data-total-allocation-id="${$allocationId}"]`).length > 0 ?
        $(`input[data-total-allocation-id="${$allocationId}"]`) :
        $(`input[type="number"][data-toggle*=${$allocationId}]`);

    const $displayTotal = $(component).find('span.total-allocation');
    const $hiddenTotal = $(component).find('input.total-allocation');

    const computeTotalAllocation = () => {
        let total = 0;

        $allocationItems.each((i, input) => {
            const inputVal = (input.value !== '') ? input.value : 0;
            total += parseInt(inputVal, 10);
        });

        return total;
    };

    // compute total on page load
    updateDisplayTotal({
        display: $displayTotal,
        hidden: $hiddenTotal,
        value: computeTotalAllocation()
    });

    // process total on item change
    $allocationItems.on('change', () => {
        // updateTotalAllocationDataAttributeValue(event.target);
        updateDisplayTotal({
            component,
            display: $displayTotal,
            hidden: $hiddenTotal,
            value: computeTotalAllocation()
        });
    });
};

$(() => {
    const $totalAllocation = $('.form-total-allocation');

    if ($totalAllocation.length) {
        $totalAllocation.each(totalAllocationInit);
    }
});
